import { getAuthHeaders, getBaseUrl } from './apiClient';

export interface CourseStage {
  stage_id: string;
  name: string;
  order: number;
  type: string;
  model?: string;
  temperature?: number | null;
  max_tokens?: number;
  thinking?: { type: string; budget_tokens: number } | null;
  system_prompt?: string | null;
  prompt_template?: string | null;
  status: string;
  updatedAt?: string;
  updatedBy?: string;
}

export const courseStagesService = {
  async list(): Promise<{ stages: CourseStage[]; count: number }> {
    const resp = await fetch(`${getBaseUrl()}/secure/courses/stages`, {
      headers: await getAuthHeaders(),
    });
    if (!resp.ok) throw new Error(`Failed to list stages (${resp.status})`);
    return resp.json();
  },

  async update(stageId: string, payload: Partial<CourseStage>): Promise<CourseStage> {
    const resp = await fetch(
      `${getBaseUrl()}/secure/courses/stages/${encodeURIComponent(stageId)}`,
      {
        method: 'PUT',
        headers: await getAuthHeaders(),
        body: JSON.stringify(payload),
      },
    );
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Failed to update stage: ${resp.status} ${text}`);
    }
    return resp.json();
  },
};
